import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";

import ButtonTS from "components/Forms/CustomButtons/ButtonTS";

export default function Unauthorized() {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation("message");

  return (
    <div
      style={{
        width: "100%",
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2>
        <strong>{t("access")}</strong>
      </h2>
      <ButtonTS
        color="danger"
        onClick={() =>
          keycloak.logout({
            redirectUri: `${window.location.origin}/auth/login`,
          })
        }
      >
        {t("end-session")}
      </ButtonTS>
    </div>
  );
}
